import { Box } from "@mui/material";
import { useContext } from "react";
import { ParagraphText, UBButton } from "../../../../Libraries";
import { LanguageContext } from "../../../../context/LanguageContext";
import { InvoiceIcon } from "../../../../assets/icons/icon";
import styles from "./InvoicePromoBanner.module.css";
import { sentenceCase } from "../../../../constants";

const InvoicePromoBanner = ({
  className = "",
  icon,
  title,
  subtitle,
  ctaLabel,
  ctaId = "CreateInvoiceBanner",
  onCtaClick,
  onCreateInvoice,
}) => {
  const [I18n] = useContext(LanguageContext);

  return (
    <Box className={`${styles.banner} ${className}`}>
      <Box className={styles.bannerLeft}>
        <span className={styles.bannerIcon}>
          {icon || <InvoiceIcon width={18} height={18} />}
        </span>
        <Box>
          <ParagraphText className={styles.bannerTitle}>
            {title || I18n.get_paid_faster}
          </ParagraphText>
          <ParagraphText className={styles.bannerSubtitle}>
            {subtitle || I18n.get_paid_faster_subtitle}
          </ParagraphText>
        </Box>
      </Box>
      <UBButton
        title={sentenceCase(ctaLabel || I18n.create_invoice)}
        id={ctaId}
        onClick={onCtaClick || onCreateInvoice}
        className={`ubButtonStyle ${styles.createInvoiceButton}`}
      />
    </Box>
  );
};

export default InvoicePromoBanner;
